<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else>
      <v-layout wrap>
        <v-flex class="screen-title mb-0" xs12>
          <span>Event Entries</span>
        </v-flex>
        <v-flex>
          <div class="mb-32 title-description">
            Here you can see all the attendees of your event which have checked in.
          </div>
        </v-flex>
        <v-flex xs12>
          <data-table
            :items="attendees"
            item-clickable
            :headers="[
              { text: 'Name', align: 'left', value: 'firstName' },
              { text: 'Last name', align: 'left', value: 'lastName' },
              { text: 'Status', align: 'left', value: 'status' },
              { text: 'Time of entry', align: 'left', value: 'createdAt' },
            ]"
            @item-click="
              goTo(routes.organizer.editAccreditation, {
                eventId: eventId,
                accreditationId: $event.id,
              })
            "
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import DataTable from '../shared/data-table'
import Spinner from '../shared/spinner'
import { GET_SCANNED_ATTENDEES } from '../../graphql/scans.graphql'
import { formatDate } from '../../utils'

export default {
  name: 'scanned-attendees-container',
  components: {
    Spinner,
    DataTable,
  },
  props: {
    eventId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      attendees: [],
    }
  },
  apollo: {
    getScannedAttendees: {
      query: GET_SCANNED_ATTENDEES,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          const { getScannedAttendees: scannedAttendees } = data
          if (!scannedAttendees) {
            return (this.attendees = [])
          }
          this.attendees =
            scannedAttendees && scannedAttendees.length > 0
              ? scannedAttendees.map(this.mapScannedAttendee)
              : []
        }
      },
    },
  },
  methods: {
    mapScannedAttendee(s) {
      const { attendee, ...rest } = s
      const { status, createdAt } = rest

      return {
        createdAt: formatDate(createdAt),
        status: status.toUpperCase(),
        ...attendee,
      }
    },
  },
}
</script>

<style></style>
